import { useCallback } from 'react';
import { CONFIG } from '@frameio/config';
import { useCopyText } from '@frameio/vapor-migration';
import { getLink } from '../getLink';
import type { GetLinkParams } from '../types';
import TEXT from './generated/TEXT/useCopyLink';

TEXT.DEFINE({
  copyLinkSuccess: 'Link copied',
});

export const useCopyLink = (displaySuccessToast = true) => {
  const { copyText } = useCopyText({
    displaySuccessToast,
  });

  return useCallback(
    (
      urlParamsOrHref: GetLinkParams | string,
      successMessage = TEXT.copyLinkSuccess
    ) => {
      let origin = CONFIG.appServerOrigin;
      if (origin.includes('local-integrations')) {
        origin = origin.replace('local-integrations', 'next');
      } else if (origin.includes('integrations')) {
        origin = origin.replace('integrations', 'next');
      }
      const href =
        typeof urlParamsOrHref === 'string'
          ? urlParamsOrHref
          : getLink(urlParamsOrHref);
      const url = new URL(href, origin);
      copyText(url.toString(), successMessage);
    },
    [copyText]
  );
};
